var HandlerModule = require( 'kitbuilder-frontend/handler-module' ),
	GlobalHandler;

GlobalHandler = HandlerModule.extend( {
	onInit: function() {
		HandlerModule.prototype.onInit.apply( this, arguments );

		var $element = this.$element;

		var animation = $element.data( 'animation' );

		if ( ! animation ) {
			return;
		}

		$element.addClass( 'kitbuilder-invisible' ).removeClass( animation );

		kitbuilderFrontend.waypoint( $element, function() {
			$element.removeClass( 'kitbuilder-invisible' ).addClass( 'animated ' + animation );
		}, { offset: '90%' } );
	}
} );

module.exports = function( $scope ) {
	if ( kitbuilderFrontend.isEditMode() ) {
		return;
	}

	new GlobalHandler( { $element: $scope } );
};
